@if (damage) {
  <app-upward-accordion [hasHeader]="false" (onClose)="smartphotoService.selectDamageForActions(undefined)">
    <div content-header class="header">{{ 'actions.damage_estimation_actions' | i18nextEager }}</div>
    <div class="content">
      @for (action of damageActions; track action.label) {
        <div class="content__item">
          <bdeo-link
            size="medium"
            color="{{ action.color }}"
            icon="{{ action.icon }}"
            (click)="action.callback(damage)"
            [attr.data-test-id]="action.label"
            >{{ action.label | i18nextEager }}</bdeo-link
          >
        </div>
      }
    </div>
  </app-upward-accordion>
}
